import React from 'react';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Modal, Col } from 'react-bootstrap';

export default function UWPopUp(props) {
    const { show, onHide } = props;
    return (
        <Modal show={show} onHide={onHide} animation={false} centered size='lg'>
            <Modal.Header className='pb-0'>
                <Modal.Title>Help Me Decide: Underwriting Type</Modal.Title>
                <IconButton className="close-button" aria-label="close" onClick={onHide}>
                    <CloseIcon />
                </IconButton>
            </Modal.Header>
            <Modal.Body>
                <Col className='UW-PopUp'>
                    <p className='pt-1'>Accelerated underwriting may be a possibility if your client can answer “no” to the following questions:</p>
                    <ul className='mt-2 mb-4'>
                        <li>Has your client received treatment for or been prescribed medication for any major medical condition within the past 5 years?</li>
                        <li>Within the past 24 months has your client been:</li>
                        <li className='ml-4 list-type'>Declined by another life insurance carrier?</li>
                        <li className='ml-4 list-type'>Hospitalized for a psychiatric or medical reason (other than orthopedic related injury)?</li>
                        <li className='ml-4 list-type'>Filed for Bankruptcy?</li>
                        <li className='ml-4 list-type'>Disabled or collected Social Security Income benefits for more than six months?</li>
                        <li>In the past 10 years has your client been charged with a felony conviction, DUI, or reckless driving?</li>
                        <li>Has your client ever sought or received advice, counseling or treatment for the use of alcohol or drugs, including prescription medications?</li>
                        <li>Within the last ten years, have you ever been treated for, or diagnosed as having a heart condition, chest pain, stroke, cancer, diabetes, alcohol abuse or drug dependency?</li>
                    </ul>
                </Col>
            </Modal.Body>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/PopUps/UWPopUp/UWPopUp.js